import Board from "../../components/Board";
import BoardDetail from "../../components/BoardDetail";
import Pagination from "../../components/Pagination";
import data from "../../data/notice.json";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import styles from "../../styles/archive/Notice.module.css";
import classNames from "classnames/bind";

const cx = classNames.bind(styles);

export default function Notice() {
  const colums = [
    {
      key: "id",
      label: "번호",
      style: { width: "30px", minWidth: "60px", textAlign: "center" },
    },
    { key: "title", label: "제목" },
    {
      key: "date",
      label: "작성일",
      style: { width: "15%", minWidth: "100px", textAlign: "center" },
    },
    {
      key: "writer",
      label: "작성자",
      style: { width: "12%", minWidth: "80px", textAlign: "center" },
    },
  ];

  const noticeData = data.notice;
  const { id } = useParams();
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const pageSize = 10;
  const totalPages = Math.ceil(noticeData.length / pageSize);

  const selectedPost = id
    ? noticeData.find((item) => String(item.id) === id)
    : null;
  const currentData = noticeData.slice((page - 1) * pageSize, page * pageSize);

  useEffect(() => {
    if (id && !selectedPost) {
      alert("존재하지 않는 게시글입니다.");
      navigate("/archive/notice", { replace: true });
    }
  }, [id, selectedPost, navigate]);

  return (
    <div className={cx("noticeWrap")}>
      <div className={cx("title")}>
        <h4>공지사항</h4>
      </div>
      {id ? (
        <BoardDetail data={selectedPost} />
      ) : (
        <>
          <Board columns={colums} data={currentData} />
          <Pagination
            page={page}
            totalPages={totalPages}
            onPageChange={setPage}
          />
        </>
      )}
    </div>
  );
}
